import { Component, Vue, Inject } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase';
import _ from 'lodash';

@Component
export default class UserRoleTreeMixin extends AbpBase {
      get sysType()
      {
          return "Sys";
      }
      get permissionType()
      {
          return "Per";
      }
    userRoleIds = [];
    selectedNodes = [];
    renderContent(h, { root, node, data }) {
        return h(
            "span",
            {
                style: {
                    display: "inline-block",
                    width: "100%"
                }
            },
            [
                h("span", [
                    h("span", data.title)
                ])
            ]
        );
    }

    initTreeChildren(parent,role) {
        if (!_.isNil(role.roles) && role.roles.length>0) {
            _.forEach(role.roles, element => {
                var item = {
                    title : element.displayName,
                    name: element.displayName,
                    key: element.id,
                    expand: !_.isNil(element.roles) && element.length>0,
                    children: !_.isNil(element.roles) && element.length>0?  element.roles : [],
                    checked: false,
                    type: !_.isNil(element.roles) && element.length>0? this.sysType: this.permissionType
                };
                if(!_.isNil(this.userRoleIds) && this.userRoleIds.length>0)
                {
                    item.checked = _.includes(this.userRoleIds, item.key);
                    if (item.checked) {
                        this.selectedNodes.push(item.key);
                    }
                }
                parent.children.push(item);
                this.initTreeChildren(parent,element);
           });{
               
            }
        } 
    }

    initTree(treeData) {
        debugger;
        const roles = treeData.roles;
        this.userRoleIds = treeData.userRoleIds;
        var tree = [];
        _.forEach(roles, element => {
            if (!_.isNil(element.roles) && element.roles.length>0) {
                var item = {
                    title : element.displayName,
                    name: element.displayName,
                    key: element.id,
                    expand: false,
                    children: [],
                    checked: false,
                    type: this.sysType

                };
                tree.push(item);
                this.initTreeChildren(item, element);
            }
            else {
                var item = {
                    title : element.displayName,
                    name: element.displayName,
                    key: element.id,
                    expand: false,
                    children: [],
                    checked: false,
                    type: this.permissionType
    
                };
                if(!_.isNil(this.userRoleIds) && this.userRoleIds.length>0)
                {
                    item.checked = _.includes(this.userRoleIds, item.key);
                    if (item.checked) {
                        this.selectedNodes.push(item.key);
                    }
                }
                tree.push(item);
            }
        });
        return tree;
    }
}